import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'
import type { DayOfWeek } from '@/shared/enums/DayOfWeekEnum'

export class ShiftTemplateFilterEntity {
  dayOfWeek?: DayOfWeek
  time?: Date[]
  region?: RegionMiniEntity
  duration?: Date[]
  minSize?: number
  maxSize?: number
  page?: number
  limit?: number
}
